// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import "../_sass/main.scss";

import styles from "../_sass/main.scss";

const getSassStyle = () => styles;
export default getSassStyle;
